<template>
  <el-dialog
    v-drag
    title="上传预报文件"
    :visible.sync="dialogVisible"
    width="506px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <el-button type="text" style="left: 20px;" @click="download">
        <svg-icon
          iconClass="download"
          className="icon"
        />
        下载预报模板
      </el-button>
      <div>
        <el-upload
          class="upload-demo"
          drag
          action="#"
          :file-list="fileList"
          :show-file-list="false"
          :http-request="httpRequest"
        >
          <svg-icon iconClass="upload" className="icon" />
          <p class="el-upload__text">将文件拖到此处</p>
          <p class="el-upload__text">或</p>
          <div class="btn flex_c_c">选择文件</div>
        </el-upload>
        <div v-if="fileList.length" class="fileList">
          <div class="progress">
            <el-progress
              type="circle"
              :width="40"
              :height="40"
              :stroke-width="4"
              :percentage="porgress"
            ></el-progress>
          </div>
          <div class="file">
            <p v-tooltip="166" class="fileName">{{ fileList[0]?.fileName }}</p>
            <p class="fileSize">{{ fileList[0]?.fileSize }} mb</p>
          </div>
          <div class="opt">
            <i class="el-icon-delete" title="删除" @click="deleteFile" />
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-loading="loading" class="ok flex_c_c" @click="ok">确定</div>
    </span>
  </el-dialog>
</template>

<script>
// import { uploadMBLFile } from '@/api/system'
import { uploadMBLProduct } from '@/api/bill'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      tpye: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      fileList: [],
      porgress: 0,
      file: null
    }
  },
  methods: {
    download() {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      const guid = 'x6pkh4ex5off49ftl7v38p37cbu2o87x'
      elink.href = `/api/SystemFile/downLoadTemplate?guid=${guid}`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    },
    cancel() {
      this.$emit('cancel')
        this.reset()
    },
    reset() {
      this.active = 0
      this.fileList = []
      this.porgress = 0
      this.file = null
    },
    async ok() {
        const formData = new FormData()
        formData.append('file', this.file)
        try {
          this.loading = true
          const res = await uploadMBLProduct({ mblId: this.rowData.id }, formData)
          this.loading = false
          if (res.data.success) {
            this.$message.success('上传成功')
            this.$emit('ok', [])
            // const res1 = await unknowProducts({ mblId: this.rowData.id })
            // if (res1.success) {
            //   this.$emit('ok', res1.data || [])
            // } else {
            //   this.$message.error(res1.data.errorMessage)
            // }
          } else {
            this.$message.error(res.data.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
    },
    deleteFile() {
      this.fileList = []
      this.porgress = 0
    },
    httpRequest(e) {
      const fileName = e.file.name
      if (fileName.length > 80) {
        this.$message.error('文件名字长度不能超过80')
        return
      }
      const suffix = fileName.slice(
        fileName.lastIndexOf('.') + 1,
        fileName.length
      )
      if (suffix !== 'xlsx') {
        this.$message.error('请上传xlsx文件')
        return
      }
      this.fileList.splice(0, this.fileList[0] ? 1 : 0, {
        fileName: e.file.name,
        fileSize: Math.ceil(e.file.size / (1024 * 1024))
      })
      this.porgress = 0
      this.file = e.file
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 86px);
  margin: 0 auto;
  & > .btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    overflow: hidden;
    & > div {
      width: 50%;
      height: 40px;
      background: #ffffff;
      font-size: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      border: 1px solid #eeeeee;
      box-sizing: border-box;
      cursor: pointer;
      & + div {
        border-left: 0;
      }
      &.active {
        color: #FFFFFF;
        background:  rgb(18,88,188);
      }
    }
  }
  .upload-demo {
    width: 100%;
    height: 200px;
    margin-top: 10px;
    .btn {
      width: 120px;
      height: 40px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid  rgb(18,88,188);
      margin: 10px auto 0;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color:  rgb(18,88,188);
    }
    .icon {
      font-size: 40px;
      color:  rgb(18,88,188);
      margin-top: 24px;
    }
  }
  &:deep(.el-upload) {
    width: 100%;
    height: 200px;
  }
  &:deep(.el-upload-dragger) {
    width: 100%;
    height: 200px;
  }
  &:deep(.el-upload-dragger) {
    background: #f7f7f7;
  }
  &:deep(.el-upload__text) {
    width: 100%;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    margin-top: 10px;
  }
  .fileList {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 64px;
    box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.1);
    border-radius: 6px 6px 6px 6px;
    box-sizing: border-box;
    padding: 0 10px;
    margin-top: 10px;
    & > div {
      line-height: normal;
    }
    .progress {
      width: 40px;
      height: 40px;
    }
    .file {
      width: 280px;
      .fileName {
        font-size: 14px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .fileSize {
        font-size: 12px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
    }
    .opt {
      .el-icon-delete {
        font-size: 24px;
        color: #cdcdcd;
        cursor: pointer;
      }
    }
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  & div {
    width: 120px;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #999999;
    margin-right: 16px;
  }
  .ok {
    background:  rgb(18,88,188);
    color: #ffffff;
  }
}
</style>
